import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { PagesRoutingModule } from './page-routing.module';
import { SharedModule } from '../shared/shared.module';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxYoutubePlayerModule } from 'ngx-youtube-player';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgImageSliderModule } from 'ng-image-slider';
import { Index5Component } from './index5/index5.component';
import { TeximateModule } from 'ngx-teximate';

@NgModule({
  declarations: [ Index5Component],
  imports: [
    TeximateModule,NgImageSliderModule,CommonModule, ScrollToModule.forRoot(), PagesRoutingModule, SharedModule, NgbModalModule, NgxYoutubePlayerModule
  ]
})
export class PagesModule { }

